module.exports = __webpack_public_path__ + "img/6.86ff2669.jpg";